<template>
  <!-- eslint-disable -->
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isShowLeftSidebar"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-show-left-sidebar', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Thông tin cán bộ</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>
      <!-- BODY -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form -->
        <b-form
          id="newCBCCFrom"
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <h4 class="app-label">
            <span class="align-left">Cơ quan</span>
          </h4>
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Đơn vị"
                rules="required"
              >
                <b-form-group
                  label="Đơn vị"
                  label-for="donvi"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    class="form-el"
                    id="donVi"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.donVi.id"
                    :options="donVis"
                    :reduce="(val) => val.id"
                    label="name"
                    :clearable="false"
                    :disabled="isWait || (formData.id && formData.id != '')"
                    input-id="donVi"
                    @input="onChangeDonVi"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Phòng ban"
                rules=""
              >
                <b-form-group
                  label="Phòng ban"
                  label-for="phongBan"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.phongBan"
                    :reduce="(val) => val"
                    :options="phongBans"
                    label="name"
                    :clearable="false"
                    :disabled="isWait"
                    input-id="phongBan"
                  >
                    <template #option="{ name, level, parents }">
                      <span
                        v-if="level > 1"
                        :class="[level > 1 ? 'ml-' + (level - 2) : '']"
                      >
                        <feather-icon
                          icon="CornerDownRightIcon"
                          size="16"
                          class="align-middle"
                        />
                      </span>
                      <span>
                        {{ name }}
                      </span>
                    </template>
                  </v-select>
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <h4 class="app-label">
            <span class="align-left">Thông tin cá nhân</span>
          </h4>
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Mã CBCCVC"
                rules=""
              >
                <b-form-group label="Mã CBCCVC" label-for="soHieuCBCCVC">
                  <b-form-input
                    class="form-el"
                    id="soHieuCBCCVC"
                    v-model="formData.soHieuCBCCVC"
                    :state="getValidationState(validationContext)"
                    :disabled="isWait"
                    placeholder="Mã CBCCVC"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Họ và Tên"
                rules="required"
              >
                <b-form-group label="Họ và tên" label-for="hoVaTen">
                  <b-form-input
                    class="form-el"
                    id="hoVaTen"
                    v-model="formData.hoVaTen"
                    :state="getValidationState(validationContext)"
                    :disabled="isWait"
                    placeholder="Họ và Tên"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Giới tính"
                rules=""
              >
                <b-form-group
                  label="Giới tính"
                  label-for="gioiTinh"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.gioiTinh"
                    :reduce="(val) => val"
                    :options="commonData.DM_GIOITINH"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="gioiTinh"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Ngày sinh"
                rules=""
              >
                <b-form-group
                  label="Ngày sinh"
                  label-for="ngaySinh"
                  :state="getValidationState(validationContext)"
                >
                  <b-form-datepicker
                    id="ngaySinh"
                    v-model="formData.ngaySinh"
                    :state="getValidationState(validationContext)"
                    :disabled="isWait"
                    placeholder="Ngày sinh"
                    locale="vi"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                  />

                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <h4 class="app-label">
            <span class="align-left">Ngạch, bậc, chức vụ</span>
          </h4>
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Giới tính"
                rules=""
              >
                <b-form-group
                  label="Ngạch"
                  label-for="ngach"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.ngach"
                    :reduce="(val) => val"
                    :options="commonData.DM_NGACHCHUCDANH"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="ngach"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Chức vụ"
                rules=""
              >
                <b-form-group
                  label="Chức vụ"
                  label-for="chuVu"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.chucVu"
                    :reduce="(val) => val"
                    :options="commonData.DT_DM_CHUCVU"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="chucVu"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Thạng thái hồ sơ"
                rules=""
              >
                <b-form-group
                  label="Thạng thái hồ sơ"
                  label-for="trangThaiHoSo"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.trangThaiHoSo"
                    :reduce="(val) => val"
                    :options="commonData.DM_TRANGTHAIHOSO"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="trangThaiHoSo"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Ngày đảm nhiệm"
                rules=""
              >
                <b-form-group
                  label="Ngày đảm nhiệm"
                  label-for="ngayDamNhiem"
                  :state="getValidationState(validationContext)"
                >
                  <b-form-datepicker
                    id="ngayDamNhiem"
                    v-model="formData.ngayDamNhiem"
                    :state="getValidationState(validationContext)"
                    :disabled="isWait"
                    placeholder="Ngày đảm nhiệm"
                    locale="vi"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                  />

                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-form-checkbox v-model="formData.laDangVien">
                  Đảng Viên
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <h4 class="app-label">
            <span class="align-left">Trình độ đào tạo</span>
          </h4>
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Trình độ văn hóa"
                rules=""
              >
                <b-form-group
                  label="Trình độ văn hóa"
                  label-for="trinhDoVanHoa"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.trinhDoVanHoa"
                    :reduce="(val) => val"
                    :options="commonData.TrinhDoVanHoa"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="trinhDoVanHoa"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Trình độ đào tạo"
                rules=""
              >
                <b-form-group
                  label="Trình độ đào tạo"
                  label-for="trinhDoDaoTao"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.trinhDoDaoTao"
                    :reduce="(val) => val"
                    :options="commonData.DM_TRINHDODAOTAO"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="trinhDoDaoTao"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Lý luận chính trị"
                rules=""
              >
                <b-form-group
                  label="Lý luận chính trị"
                  label-for="lyLuanChinhTri"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.lyLuanChinhTri"
                    :reduce="(val) => val"
                    :options="commonData.DM_TRINHDOLLCT"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="lyLuanChinhTri"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Quản lý nhà nước"
                rules=""
              >
                <b-form-group
                  label="Quản lý nhà nước"
                  label-for="quanLyNhaNuoc"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.quanLyNhaNuoc"
                    :reduce="(val) => val"
                    :options="commonData.DM_TRINHDOQLNN"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="quanLyNhaNuoc"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Trình độ tiếng anh"
                rules=""
              >
                <b-form-group
                  label="Trình độ tiếng anh"
                  label-for="tiengAnh"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.tiengAnh"
                    :reduce="(val) => val"
                    :options="commonData.DM_TRINHDONGOAINGU"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="tiengAnh"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Trình độ tin học"
                rules=""
              >
                <b-form-group
                  label="Trình độ tin học"
                  label-for="tinHoc"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.tinHoc"
                    :reduce="(val) => val"
                    :options="commonData.DM_TRINHDOTINHOC"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="tinHoc"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <validation-provider
                #default="validationContext"
                name="Ngoại ngữ khác"
                rules=""
              >
                <b-form-group
                  label="Ngoại ngữ khác"
                  label-for="ngoaiNgu"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.ngoaiNgu"
                    multiple
                    :reduce="(val) => val"
                    :options="commonData.DM_NGOAINGU"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="ngoaiNgu"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <div class="d-flex mt-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mr-2"
                  :disabled="isWait"
                  type="submit"
                >
                  Save
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="button"
                  variant="outline-secondary"
                  :disabled="isWait"
                  @click="hide"
                >
                  Cancel
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
/* eslint-disable */
import {
  BRow,
  BCol,
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormDatepicker,
  BFormCheckbox,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, alphaNum, email, url } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  CanBoCongChucCreate as dataCreate,
  CanBoCongChucUpdate as dataUpdate,
} from "@/services/api/HoSoCanBoCongChuc/CanBoCongChucService";
import { ref, computed, watch } from "@vue/composition-api";
import useSetup from "../useSetup";

const defaultData = {
  id: null,
  name: null,
  code: null,
};

export default {
  components: {
    BRow,
    BCol,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    BFormDatepicker,
    BFormCheckbox,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    donVis: {
      type: Array,
      required: true,
    },
    donViDefaultSelected: {
      type: Object,
      default: {},
    },
    formData: {
      type: Object,
      default: {},
      required: true,
    },
    isShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
    commonData: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.formData.donVi = {
      id: this.donViDefaultSelected.value,
    };

    //TODO set Defaut ==================
    this.formData.gioiTinh = Object.assign({}, defaultData);
    this.formData.phongBan = Object.assign({}, defaultData);
  },
  watch: {
    isShowLeftSidebar(val) {
      if (val) {
        if (this.formData.donVi == null) {
          this.formData.donVi = {
            id: this.donViDefaultSelected.value,
          };
        } else {
          this.formData.donVi.id = this.donViDefaultSelected.value;
        }
        //TODO ==================
        if (this.formData.gioiTinh == null) {
          this.formData.gioiTinh = Object.assign({}, defaultData);
        }

        if (this.formData.phongBan == null) {
          this.formData.phongBan = Object.assign({}, defaultData);
        }

        this.onChangeDonVi(this.donViDefaultSelected.value);
      }
    },
  },
  data() {
    return {
      isWait: false,

      required,
      alphaNum,
      email,
      url,
    };
  },
  methods: {
    async onSubmit() {
      if (this.isWait) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Notification",
            icon: "CoffeeIcon",
            variant: "info",
            text: "In Progress",
          },
        });
      } else {
        if (this.formData.id && this.formData.id != "") {
          //Update
          this.isWait = true;

          //Update DonVi info
          let index = this.donVis.findIndex(
            (el) => el.id == this.formData.donVi.id
          );
          if (index != -1) {
            this.formData.donVi = JSON.parse(
              JSON.stringify(this.donVis[index])
            );
          }

          var res = await dataUpdate(this.formData);
          this.isWait = false;
          if (res.isError) {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Thất bại",
                icon: "AlertTriangleIcon",
                variant: "error",
                text: res.message,
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Thành công",
                icon: "CheckIcon",
                variant: "success",
                text: res.message,
              },
            });
            this.$emit("update:is-show-left-sidebar", false);
            this.$emit("refetch-data", this.formData);
          }
        } else {
          //Create
          this.isWait = true;

          //Update DonVi info
          let index = this.donVis.findIndex(
            (el) => el.id == this.formData.donVi.id
          );
          if (index != -1) {
            this.formData.donVi = JSON.parse(
              JSON.stringify(this.donVis[index])
            );
          }

          var res = await dataCreate(this.formData);
          this.isWait = false;
          if (res.isError) {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Thất bại",
                icon: "AlertTriangleIcon",
                variant: "error",
                text: res.message,
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Thành công",
                icon: "CheckIcon",
                variant: "success",
                text: res.message,
              },
            });
            //this.formData.id = res.data.id
            this.$emit("update:is-show-left-sidebar", false);
            this.$emit("refetch-data", this.formData, res.data.id);
          }
        }
      }
    },
  },
  setup(props, { emit }) {
    const { refFormObserver, getValidationState, resetForm } = formValidation(
      () => {
        //Reset form
      }
    );

    const { loadPhongBan } = useSetup();
    const phongBans = ref([]);
    const onChangeDonVi = (donViId) => {
      loadPhongBan(
        {
          parentId: donViId,
        },
        function (data) {
          phongBans.value = data;
        }
      );
    };

    return {
      refFormObserver,
      getValidationState,
      resetForm,

      phongBans,
      onChangeDonVi,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
#add-new-user-sidebar {
  width: 90%;
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
